export const MANAGE_CAMERAS_LIST = 'MANAGE_CAMERAS_LIST';
export const MANAGE_CAMERAS_LIST_RESPONSE = 'MANAGE_CAMERAS_LIST_RESPONSE';

export const MANAGE_CAMERAS_PAIR_DEVICE = 'MANAGE_CAMERAS_PAIR_DEVICE';
export const MANAGE_CAMERAS_PAIR_DEVICE_RESPONSE = 'MANAGE_CAMERAS_PAIR_DEVICE_RESPONSE';

export const MANAGE_CAMERAS_UNPAIR_DEVICE = 'MANAGE_CAMERAS_UNPAIR_DEVICE';
export const MANAGE_CAMERAS_UNPAIR_DEVICE_RESPONSE = 'MANAGE_CAMERAS_UNPAIR_DEVICE_RESPONSE';

export const MANAGE_CAMERAS_OPEN_MODAL = 'MANAGE_CAMERAS_OPEN_MODAL';